import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';
import { useGlobalModalStore } from '@doltech/ui/lib/hocs/withGlobalModal';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ButtonGeneral } from '@doltech/ui/lib/figma/Button/ButtonGeneral/ButtonGeneral';

const Main = styled.div`
  background-color: ${colorsV2.white100};
  border-radius: 16px;

  display: grid;
  .btn {
    border-radius: 8px;
    padding: 8px 16px;
    outline: none;
    border: none;
    transition: all 0.3s ease;
    cursor: pointer;
    &.size-large {
      height: 40px;
    }
    &.primary {
      background: ${colorsV2.primary100};
      color: ${colorsV2.white100};
    }
    &.outline {
      border: 2px solid ${colorsV2.gray20};
      background: transparent;
    }
    &:active {
      transform: scale(0.9);
    }
    &:hover {
      transform: scale(1.02);
    }
  }
  .modal-header {
    width: 100%;
    padding: 24px 32px 8px;
    &.align-center {
      text-align: center;
    }
    &.divider {
      box-shadow: 0px -1px 0px 0px #f0f0f2 inset;
    }
  }
  .modal-content {
    width: 100%;
    padding: 12px 32px;
    &.align-center {
      text-align: center;
    }
  }
  .modal-footer {
    width: 100%;
    padding: 12px 32px 24px;
    display: grid;
    gap: 12px;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    align-items: center;

    &.align-right {
      justify-content: flex-end;
    }

    &.align-center {
      justify-content: center;
      text-align: center;
    }
    &.divider {
      box-shadow: 0 -1px 0 #f0f0f2;
    }
  }
`;

export interface ModalGeneralContentProps {
  title?: string;
  description?: string;
  primaryButton?: {
    disabled?: boolean;
    name: string;
    onClick: () => void;
  };
  secondaryButton?: {
    name: string;
    onClick: () => void;
  };
}

export const ModalGeneralContent = observer(
  ({ title, description, primaryButton, secondaryButton }: ModalGeneralContentProps) => {
    const modalStore = useGlobalModalStore();
    return (
      <Main className="not-enough-word-modal-content">
        <div className="modal-header align-center">
          <ResponsiveTypography.Paragraph className="title" variant="semi-bold/20-28">
            {title}
          </ResponsiveTypography.Paragraph>
        </div>
        <div className="modal-content align-center">
          <ResponsiveTypography.Paragraph className="description" variant="regular/14-20">
            {description}
          </ResponsiveTypography.Paragraph>
        </div>
        <Box className="modal-footer align-center">
          {secondaryButton && (
            <ButtonGeneral
              type="secondary"
              size="large"
              text={secondaryButton.name}
              onClick={() => {
                secondaryButton.onClick();
                modalStore.hide();
              }}
            />
          )}
          {primaryButton && (
            <ButtonGeneral
              disabled={primaryButton?.disabled}
              type="primary"
              size="large"
              text={primaryButton.name}
              onClick={() => {
                primaryButton.onClick();
                modalStore.hide();
              }}
            />
          )}
        </Box>
      </Main>
    );
  }
);
